import React from 'react';
import { MessageCircle, BookOpen, Settings, CheckCircle } from 'react-feather';

const Dashboard: React.FC = () => {
  return (
    <div className="space-y-6">
      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600">Total Conversations</p>
              <p className="text-2xl font-semibold text-gray-900">--</p>
            </div>
            <div className="text-eddy-blue">
              <MessageCircle size={32} />
            </div>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600">Active Content Sources</p>
              <p className="text-2xl font-semibold text-gray-900">3</p>
            </div>
            <div className="text-eddy-green">
              <BookOpen size={32} />
            </div>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600">Widget Integrations</p>
              <p className="text-2xl font-semibold text-gray-900">3</p>
            </div>
            <div className="text-eddy-orange">
              <Settings size={32} />
            </div>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600">System Health</p>
              <p className="text-2xl font-semibold text-green-600">Healthy</p>
            </div>
            <div className="text-green-500">
              <CheckCircle size={32} />
            </div>
          </div>
        </div>
      </div>

      {/* Recent Activity */}
      <div className="bg-white rounded-lg shadow">
        <div className="px-6 py-4 border-b border-gray-200">
          <h3 className="text-lg font-medium text-gray-900">Recent Activity</h3>
        </div>
        <div className="p-6">
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <div className="w-2 h-2 bg-green-500 rounded-full"></div>
              <span className="text-sm text-gray-600">System started successfully</span>
              <span className="text-xs text-gray-400">2 minutes ago</span>
            </div>
            <div className="flex items-center space-x-3">
              <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
              <span className="text-sm text-gray-600">Configuration loaded</span>
              <span className="text-xs text-gray-400">2 minutes ago</span>
            </div>
            <div className="flex items-center space-x-3">
              <div className="w-2 h-2 bg-green-500 rounded-full"></div>
              <span className="text-sm text-gray-600">Storage adapter initialized</span>
              <span className="text-xs text-gray-400">2 minutes ago</span>
            </div>
          </div>
        </div>
      </div>

      {/* Quick Actions */}
      <div className="bg-white rounded-lg shadow">
        <div className="px-6 py-4 border-b border-gray-200">
          <h3 className="text-lg font-medium text-gray-900">Quick Actions</h3>
        </div>
        <div className="p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            <button className="p-4 border border-gray-300 rounded-lg hover:bg-gray-50 text-left">
              <div className="text-eddy-blue mb-2">
                <MessageCircle size={24} />
              </div>
              <h4 className="font-medium text-gray-900">View Activity Logs</h4>
              <p className="text-sm text-gray-600">Check recent conversations and interactions</p>
            </button>
            
            <button className="p-4 border border-gray-300 rounded-lg hover:bg-gray-50 text-left">
              <div className="text-eddy-green mb-2">
                <BookOpen size={24} />
              </div>
              <h4 className="font-medium text-gray-900">Manage Content</h4>
              <p className="text-sm text-gray-600">Configure content sources and processing</p>
            </button>
            
            <button className="p-4 border border-gray-300 rounded-lg hover:bg-gray-50 text-left">
              <div className="text-eddy-orange mb-2">
                <Settings size={24} />
              </div>
              <h4 className="font-medium text-gray-900">System Settings</h4>
              <p className="text-sm text-gray-600">Configure prompts and system behavior</p>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;